import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SelectedCadomainReducer(state = initialState.selectedCadomains, action: any) {
  switch (action.type) {
    case types.SAVE_SELECTED_CADOMAINS_SUCCESS:
      return action.selectedCadomains;
    default:
      return state;
  }
}
